import React from 'react';

const MonthlyBudgetDrawerContext = React.createContext({ forms: [] });

export { MonthlyBudgetDrawerContext };
